import { render, staticRenderFns } from "./MuseumHistory.vue?vue&type=template&id=83787eb2&"
import script from "./MuseumHistory.vue?vue&type=script&lang=js&"
export * from "./MuseumHistory.vue?vue&type=script&lang=js&"
import style0 from "./MuseumHistory.vue?vue&type=style&index=0&id=83787eb2&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports